import { CacherClass } from "../helpers/CacherClass";

const defaultRequestSettings = {
    apiPath: '',
    endpoint: '',
    verb: '',
    params: '',
    useCacher: false,
    cacherLabel: '',
    cacherUrl: '',
    cacherForceReload: false,
    cacherDataType: 'json',
    cacherTimeout: 15 // minutes
}

export class HttpClass {

    constructor(settings = {}) {
        Object.assign(this, defaultRequestSettings, settings);
    }

    buildRequest() {
        // INIT
        const vm = this;
        const apiUrl = vm.apiPath + vm.endpoint + '/' + vm.verb + '/' + vm.params;
        let finalUrl = apiUrl;

        // DETECT CACHER SETTINGS
        if(vm.useCacher && vm.cacherLabel != '' && vm.cacherUrl != '') {
            // UPDATE "FINALURL" TO CACHERURL
            finalUrl = vm.buildCacherUrl();
        }

        return finalUrl;
    }

    buildCacherUrl() {
        // INIT CACHER
        const vm = this;
        const cacher = new CacherClass({
            label: vm.cacherLabel,
            dataUrl: vm.cacherUrl,
            forceReload: vm.cacherForceReload,
            cacherTimeout: vm.cacherTimeout,
            sourceDataType: vm.cacherDataType
        });

        // GET CACHER URL
        const cacherUrl = cacher.createCacherUrl();

        return cacherUrl;
    }

    async sendRequest(requestUrl) {
        try {
            let res = await fetch(requestUrl);
            res = await res.json();
            return res;
        } catch(error) {
            console.log('error: ', error);
        }
    }

}